import script from "./EditTransactionDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./EditTransactionDialog.vue?vue&type=script&setup=true&lang=js"

import "./EditTransactionDialog.vue?vue&type=style&index=0&id=59f53efd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59f53efd"]])

export default __exports__